export default class VerificationService {
  static isVerified(profile) {
    return profile.kycStatus === 'verified';
  }
}
